import { Component, DestroyRef, OnInit,Input } from '@angular/core';
import { CommonService } from './../../../services/commonService/common.service';
import { LoginService } from './../../../services/LoginService/login.service';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize } from 'rxjs/operators';
import { SharedService } from './../../../services/SharedService/sharedService';

declare let $: any;

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})
export class HeaderComponent implements OnInit {

  constructor(
    private router: Router,
    private sharedService: SharedService,
    private commonService :CommonService,
    private loginService :LoginService,
    private cookieService: CookieService,
    private destroyRef: DestroyRef,
    ) { }
  @Input() LoginDetails: any;
  Notifications: any = [];
  temp: any;
  ErrorMsg: string = '';
  Logo: string = '';
  LogoSmall: string = '';
  currentProductName = '';
  private readonly productNamesById: Record<number, string> = {
    114: 'Two Wheeler',
    117: 'Car'
  };

  ngOnInit(): void {
    this.Session()
    this.IsValidUserType()
    //this.GetNotification()
    console.log(`onInit: header component: ${JSON.stringify(this.LoginDetails)}`)
    this.setCurrentProductName(this.LoginDetails);
    this.sharedService.userDetailsSubject$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((user) => this.setCurrentProductName(user));
  }
  ngOnChanges(){
    console.log(this.LoginDetails)
    this.setCurrentProductName(this.LoginDetails);
  }

  private setCurrentProductName(user: any): void {
    const productId = Number(user?.ProductID ?? user?.ProductId ?? NaN);
    this.currentProductName =
      user?.ProductName ??
      user?.productName ??
      (Number.isFinite(productId) ? this.productNamesById[productId] : '') ??
      '';
  }
  GetNotification() {
    this.temp = [];
    let reqData = this.LoginDetails.InsurerId + "/" + this.LoginDetails.UserId + "/" + this.LoginDetails.UserType;

    this.commonService.GetNotification(reqData).subscribe((res)=> {
      if(res.Data!=null){

        this.temp = res.Data;
        this.Notifications = [];
        this.temp.forEach((value: any) => {
          var datetime = new Date();
          var t1 = datetime.getTime();
          var t2 = value.Date;
          let time: any = t2 - t1;
          time = time / 60000;
          if (time > 0) {
              if (time > 9) {
                  time = String(time).substring(0, 2) + ' mins left';
              }
              else {
                  time = String(time).substring(0, 1) + ' mins left';
              }
          }
          else {
              time = String(time).substring(1, 10);
              if (time > 9) {
                  time = time.substring(0, 2) + ' mins overdue';
              }
              else {
                  time = time.substring(0, 1) + ' mins overdue';
              }
          };

          value.Time = time;

          if (!value.IsSkipped) {
              this.Notifications.push(value);
          }
        });
        this.temp.forEach((value: any, key: any)=> {

            let datetime = new Date();
            let t1 = datetime.getTime();
            let t2 = value.Date;
            let time: any = t2 - t1;
            time = time / 60000;
            if (time > 0) {
                if (time > 9) {
                    time = String(time).substring(0, 2) + ' mins left';
                }
                else {
                    time = String(time).substring(0, 1) + ' mins left';
                }
            }
            else {
                time = String(time).substring(1, 10);
                if (time > 9) {
                    time = time.substring(0, 2) + ' mins overdue';
                }
                else {
                    time = time.substring(0, 1) + ' mins overdue';
                }
            };

            value.Time = time;

            if (!value.IsSkipped) {
                this.Notifications.push(value);
            }
        });

        //$scope.Notifications = response.data.Data;
      } else {

      }
    })
  }

  OpenClaimDetails(ClaimId: any){

  }

  Logout(): void {
    const loginId = this.LoginDetails?.LoginID;
    const clearCookies = () => {
      try {
        const host = window.location.hostname.split('.');
        if (host.length > 2) {
          this.cookieService.deleteAll(
            '/',
            '.'.concat(host[1], '.', host[2]),
          );
        }
      } catch {
        /* ignore domain cookie cleanup errors */
      }
      try {
        this.cookieService.deleteAll();
      } catch {
        /* ignore */
      }
    };

    this.loginService
      .Logout(loginId)
      .pipe(
        finalize(() => {
          // Run cleanup again when the API finishes in case anything wrote during navigation.
          this.sharedService.clearUserSession();
          clearCookies();
        }),
      )
      .subscribe({
        next: (res) => {
          if (res?.Data == null) {
            this.ErrorMsg = 'Error : Something went wrong!';
          }
        },
        error: () => {
          this.ErrorMsg = 'Error : Something went wrong!';
        },
      });

    // Do not wait for logout API response before clearing browser state and leaving protected pages.
    this.sharedService.clearUserSession();
    clearCookies();
    void this.router.navigate(['/login'], { replaceUrl: true });
  }


  Session() {
    if (this.LoginDetails.InsurerId == 0) {
        //$window.location = "login.html";
    }
    else if (this.LoginDetails.InsurerId == 12) {
        // NIA
        $('head').append('<link rel="stylesheet" type="text/css" href="assets/css/themenewindia.css">');
        this.Logo = "assets/images/national.png";
        this.LogoSmall = "assets/images/logo_national.png";
    }
    else if (this.LoginDetails.InsurerId == 8) {
        // Oriental
        //$('head').append('<link rel="stylesheet" type="text/css" href="assets/css/themenewindia.css">');
        this.LogoSmall = "assets/images/oriental_logo_sml.png";
        this.Logo = "assets/images/oriental_logo.png";
    }
    else if (this.LoginDetails.InsurerId == 11) {
        // United
        $('head').append('<link rel="stylesheet" type="text/css" href="assets/css/unitedindiainsurer.css">');
        this.LogoSmall = "assets/images/united_sm.jpg";
        this.Logo = "assets/images/united_lg.jpg";
    }
    else if (this.LoginDetails.InsurerId == 6) {
        // National
        $('head').append(' <link rel="stylesheet" type="text/css" href="assets/css/nationalinsuranceindia.css">');
        this.LogoSmall = "assets/images/national_smm.png";
        this.Logo = "assets/images/national-insurance-company.jpg";
    }
    else {
        this.LogoSmall = "assets/images/pb_small.png";
        this.Logo = "assets/images/pb_logo.png";
    }
  }


  IsValidUserType() {
    try {
        var val = this.LoginDetails.EncUserTypeID.replace('PBCLAIM', '')
        if ((parseInt(val) / 29) / this.LoginDetails.UserId != this.LoginDetails.UserType) {
            //$window.location = "login.html";
        }
    } catch (e) {
        //$window.location = "login.html";
    }
}

}
